module.exports = __webpack_public_path__ + "img/notification_setting.95270510.svg";